const splitAutocompleteUrl = (autocompleteUrl: string) => {
    const [baseUrl, ...queryParts] = autocompleteUrl.split('?');

    return {
        baseUrl,
        searchParams: new URLSearchParams(queryParts.join('?')),
    };
};

const stringifyAutocompleteUrl = (baseUrl: string, searchParams: URLSearchParams) => {
    const queryString = searchParams.toString();

    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

const updateAutocompleteSearchParams = (autocompleteUrl: string, update: (searchParams: URLSearchParams) => void) => {
    const { baseUrl, searchParams } = splitAutocompleteUrl(autocompleteUrl);
    const existingQueryValues = searchParams.getAll('query');

    searchParams.delete('query');
    update(searchParams);

    for (const queryValue of existingQueryValues) {
        searchParams.append('query', queryValue);
    }

    return stringifyAutocompleteUrl(baseUrl, searchParams);
};

export const appendPrepackageAutocompleteParams = (autocompleteUrl: string, params?: string) => {
    if (!params) {
        return autocompleteUrl;
    }

    return updateAutocompleteSearchParams(autocompleteUrl, (searchParams) => {
        for (const [key, value] of new URLSearchParams(params)) {
            searchParams.append(key, value);
        }
    });
};
